function PriceBreakdown({ pricePerDay, startDate, endDate }) {
  if (!startDate || !endDate) return null;

  const diffTime = new Date(endDate) - new Date(startDate);
  const diffHours = diffTime / (1000 * 60 * 60);

  let fullDays = 1;
  let extraCharge = 0;
  let extraLabel = "";

  if (diffHours <= 26) {
    fullDays = 1;
    extraCharge = 0;
  } else {
    fullDays = Math.floor(diffHours / 24);
    const extraHours = diffHours % 24;

    if (extraHours <= 2) {
      extraCharge = 0;
    } else if (extraHours <= 4) {
      extraCharge = 0.25 * pricePerDay;
      extraLabel = "(up to 4 hr ext.)";
    } else if (extraHours <= 6) {
      extraCharge = 0.50 * pricePerDay;
      extraLabel = "(up to 6 hr ext.)";
    } else {
      extraCharge = pricePerDay;
      extraLabel = "(> 6 hr ext.)";
    }
  }

  const baseAmount = pricePerDay * fullDays;
  const totalAmount = baseAmount + extraCharge;
  const securityDeposit = 0;
  const gst = 0;
  const total = totalAmount + securityDeposit + gst;

  return (
    <div style={styles.card}>
      <h3>💰 Price Breakdown</h3>

      <div style={styles.row}>
        <span>₹{pricePerDay} × {fullDays} day(s)</span>
        <span>₹{baseAmount}</span>
      </div>

      {extraCharge > 0 && (
        <div style={styles.row}>
          <span>Extension {extraLabel}</span>
          <span>₹{extraCharge}</span>
        </div>
      )}

      <div style={styles.row}>
        <span>Security Deposit</span>
        <span>₹{securityDeposit}</span>
      </div>

      <div style={styles.row}>
        <span>GST</span>
        <span>Included</span>
      </div>

      <hr />

      <div style={{ ...styles.row, fontWeight: "bold" }}>
        <span>Total Payable</span>
        <span>₹{total}</span>
      </div>
    </div>
  );
}

const styles = {
  card: {
    marginTop: "20px",
    padding: "18px",
    borderRadius: "10px",
    background: "#f9f9f9",
    border: "1px solid #ddd",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "8px",
  },
};

export default PriceBreakdown;
